// Native controls are the fallback. Enhance only the currently rendered clip.
if (!customElements.get('collection-film')) {
  customElements.define('collection-film', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const video = this.querySelector('video');
      const button = this.querySelector('button');
      const label = this.querySelector('[data-film-label]');
      const symbol = this.querySelector('.collection-film__symbol');
      if (!video || !button || !label || !symbol) return;
      this.video = video;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      let visible = false;
      let pausedByVisitor = false;
      let manualPlayback = false;
      const syncButton = () => {
        const playing = !video.paused;
        label.textContent = playing ? this.dataset.pauseLabel : this.dataset.playLabel;
        symbol.textContent = playing ? 'Ⅱ' : '▶';
        button.setAttribute('aria-pressed', String(playing));
      };
      const resume = () => {
        const automatic = this.dataset.autoplay === 'true' && !motion.matches && !navigator.connection?.saveData;
        if (visible && !document.hidden && !pausedByVisitor && (manualPlayback || automatic)) {
          video.play().catch(syncButton);
        }
      };
      video.muted = true;
      video.addEventListener('play', syncButton, options);
      video.addEventListener('pause', syncButton, options);
      button.addEventListener('click', () => {
        if (video.paused) {
          pausedByVisitor = false;
          manualPlayback = true;
          video.play().catch(syncButton);
        } else {
          pausedByVisitor = true;
          manualPlayback = false;
          video.pause();
        }
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) video.pause();
        else resume();
      }, options);
      motion.addEventListener('change', () => {
        if (motion.matches && !manualPlayback) video.pause();
        else resume();
      }, options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          visible = entries.some(entry => entry.isIntersecting);
          if (visible) resume();
          else video.pause();
        }, { threshold: .15 });
        this.observer.observe(this);
      }
      // Without visibility detection, the visitor starts the clip manually.
      video.controls = false;
      button.hidden = false;
      syncButton();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.video?.pause();
      this.controller = null;
    }
  });
}
